import { defineComponent as d, computed as l, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as h, createCommentVNode as n, normalizeStyle as f, createStaticVNode as p } from "vue";
const v = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "fb5de041-64ed-47a8-b07c-9c0019758660" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#fb5de041-64ed-47a8-b07c-9c0019758660)" }, u = { key: 0 }, k = /* @__PURE__ */ p('<path fill="#4a1f63" d="M0 512h512v-70l-256-32L0 442Z"></path><path fill="#0052b4" d="M0 442h512v-70l-256-32L0 372Z"></path><path fill="#d80027" d="M0 0h512v70l-256 32L0 70Z"></path><path fill="#ffda44" d="M0 70h512v70l-256 32L0 140Z"></path><path fill="#eee" d="M0 140h512v70l-32 46 32 46v70H0v-70l32-46-32-46Z"></path><path fill="#496e2d" d="M0 210h512v92H0z"></path>', 6), g = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ d({
  __name: "quechua",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (w, y) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", m, [
        e.flagName ? (s(), i("title", u, h(e.flagName), 1)) : n("", !0),
        k
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, v));
  }
});
export {
  N as default
};
//# sourceMappingURL=quechua-222d86a9.js.map
